import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoadingService } from './loading.service';
import { BYPASS_LOADER } from './loader-context.token';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    handleRequestsAutomatically!: boolean;

    /**
     * Constructor
     */
    constructor(
        private _LoadingService: LoadingService
    ) {
        // Subscribe to the auto
        this._LoadingService.auto$
            .subscribe((value) => {
                this.handleRequestsAutomatically = value;
            });
    }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const bypass = req.context.get(BYPASS_LOADER);
        // If the Auto mode is turned off, do nothing
        if (bypass) {
            return next.handle(req);
        }

        // Set the loading status to true
        this._LoadingService._setLoadingStatus(true, req.url);


        return next.handle(req).pipe(
            finalize(() => {
                // Set the status to false if there are any errors or the request is completed
                this._LoadingService._setLoadingStatus(false, req.url);
            }));
    }
}
